import { render, staticRenderFns } from "./SGPColComponent.vue?vue&type=template&id=1c733509"
import script from "./SGPColComponent.vue?vue&type=script&lang=js"
export * from "./SGPColComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports